const CLIENT_CREDENTIALS = 'mdtcJs:medtronic';

export default {
    customer: [],
    userDomInfo: {
        theme: 'theme-default',
    },
    AccountDetails: {
        isInit: false,
        user: {
            access: null,
        },
        roles: '',
        groups: null,
        pk: null,
        myOrdersPK: null,
        isCustomerLoaded: false,
        customerDetails: {},
    },
    formConfig: {
        downloadHide: [],
        featureConfiguration: {},
    },
    ajaxCall: {
        ajaxCallInProgress: false,
    },
    meData: {
        refreshTokenTimer: null,
        refreshInterval: 50, // in seconds
        decodedClientCredentials: CLIENT_CREDENTIALS,
        clientCredentials: btoa(CLIENT_CREDENTIALS),
        decodedAccessToken: null,
        accessToken: null,
        refreshToken: null,
        userName: null,
        user: null,
        loginError: {},
        isInit: false,
        customerPreferences: null,
        defaultCustomer: null,
        isInternal: false,
        customer: null,
        manageCustomerList: null,
        state: {},
        roles: [],
        distributor: {},
        refreshTokenFlag: false,
        resourceAccess: {},
        hyphenizedCulture: '',
        supportedSuppliers: [],
        submissionDetails: {
            submissionId: '',
        },
        meState: {
            LOGGED_IN: false,
            USER_DETAILS: false,
            HAS_PERMISSIONS: false,
            HAS_CUSTOMERS: false,
            HAS_RESOURCE_RIGHTS: false,
            FETCHING_PERMISSIONS: false,
            FETCHING_RESOURCE_RIGHTS: false,
            LOGIN_ERROR: false,
            APPLY_ONBOARDING: false,
        },
    },

    bootData: {
        riotIsInit: false,
        settings: {},
        translations: {},
        dateConfig: {},
        numberConfig: {},
        screenOverlay: false,
        appConfiguration: {},
        showSpinner: true,
        waitingForAPICall: 0,
    },
    modalPopup: {
        title: '',
        icon: 'error',
        contents: [],
        isOpen: false,
        footer: false,
        hasHeader: true,
    },
    wishList: {
        wishListId: '',
        wishListName: {},
        entries: [],
        errors: [],
        hasUnavailableProducts: false,
        isDefault: false,
        productCount: 0,
    },
    checkoutdata: {
        items: [],
        payerAddress: {},
    },
};
